/* src/app/shared/components/file-upload-input/file-upload-input.component.scss */
.main-container {
  display: flex;
  align-items: center;
}
.file-input {
  display: none;
}
.file-upload-container {
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #DFEBF7;
  border-radius: 5px;
  color: #6B90B3;
  font: 400 14px FranceTV Brown;
  padding: 14px;
  background-color: #FFF;
}
.file-upload-label {
  display: inline-flex;
  align-items: center;
  margin-right: 10px;
  max-width: 80%;
  overflow-x: hidden;
}
.upload-info-icon {
  color: #0083FF;
  font-size: 16px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-right: 6px;
}
/*# sourceMappingURL=file-upload-input.component.css.map */
